import { renderToStaticMarkup } from 'react-dom/server';
import type { ComponentType } from 'react';

import type { IllustrationProps } from '../types/props.type';

// An illustration as an image URL, for the components taking one (card
// media, image of a generated document).
export const illustrationUrlOf = (
  Illustration: ComponentType<IllustrationProps>,
  color: string,
): string =>
  `data:image/svg+xml;charset=utf-8,${encodeURIComponent(
    renderToStaticMarkup(<Illustration color={color} />),
  )}`;
